//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as urls from '@/api/index'

export default {
    mounted() {
        //上个页面编辑邮箱传过来的数据
        let t = this, queryData = t.$route.query.data;
        if (queryData) {
            t.name = queryData.name;
            t.emailAddress = queryData.emailAddress;
            t.id = queryData.id;
        }
    },
    data() {
        return {
            id: 0,
            name: '',
            emailAddress: '',
            regEmail: new RegExp("^([A-Za-z0-9_\\-\\.])+\\@([A-Za-z0-9_\\-\\.])+\\.([A-Za-z]{2,4})$"),
        }
    },
    methods: {
        //保存邮箱
        saveEmail() {
            let t = this;
            //姓名和邮箱筛选
            if (!t.name) {
                alert('姓名不能为空');
                return;
            }
            if (!t.emailAddress) {
                alert('邮箱不能为空')
                return;
            }
            if (!t.regEmail.test(t.emailAddress)) {
                alert('邮箱格式不正确')
                return;
            }
            //要传给后台的数据封装在data里
            let data = {
                    name: t.name,
                    emailAddress: t.emailAddress,
                },
                method = '';
            //判断上个页面传数据没有，从而决定是添加还是编辑
            if (t.$route.query.data) {
                //有数据是编辑邮箱，给data里添加一个id
                data.id = t.id;
                method = 'changeEmail';
            } else {
                method = 'addEmail';
            }
            //添加或者编辑邮箱接口
            urls[method](data).then(res => {
                if (res.data.code === 0) {
                    t.$router.replace('/selectEmail')
                } else {
                    t.$vux.toast.text(res.data.msg, 'middle');
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/email/addEmail.vue